<app-sidebar-popout
  *appI18nScopeReady
  [title]="'data_management' | i18n"
  icon="storage"
  [groups]="groups()"
  [activeItemId]="activeSectionKey()"
  [searchPlaceholder]="'search_managed_data' | i18n"
  [emptyMessage]="'no_managed_data_sections' | i18n"
  [showSettings]="canEdit()"
  [settingsLabel]="'manage_sections_entry' | i18n"
  [sortToggleIcon]="sortMode() === 'group' ? 'sort_by_alpha' : 'workspaces'"
  [sortToggleTitle]="sortMode() === 'group' ? ('sort_alphabetical' | i18n) : ('sort_by_group' | i18n)"
  (popoutClose)="popoutClose.emit()"
  (itemSelect)="onItemSelect($event)"
  (itemAction)="onSectionShare($event)"
  (settings)="openSectionManager()"
  (sortToggle)="toggleSortMode()"
/>
